export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-04_DE.41d518df.png";